import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, mergeProps as _mergeProps, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-0 z-50 flex justify-center bg-black/60" }
const _hoisted_2 = { class: "p-0 bg-gray-50 shadow-xl border border-gray-200 rounded-md text-center" }
const _hoisted_3 = { class: "flex flex-col w-full text-black" }
const _hoisted_4 = {
  key: 0,
  class: "absolute inset-0 flex items-center justify-center z-50 bg-black/20"
}
const _hoisted_5 = { class: "flex flex-col w-full rounded-t-md p-3 bg-gradient-to-r from-[#424c42] to-[#647064]" }
const _hoisted_6 = { class: "font-semibold text-white text-sm md:text-2xl truncate whitespace-nowrap overflow-hidden text-ellipsis" }
const _hoisted_7 = {
  key: 0,
  class: "text-white text-sm md:text-xl truncate whitespace-nowrap overflow-hidden text-ellipsis uppercase"
}
const _hoisted_8 = { class: "w-full p-4 text-left" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "w-full flex flex-row items-center justify-center px-5 py-5 text-2xl font-semibold text-center text-gray-500" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "w-full flex flex-row items-center justify-center px-5 py-5 text-2xl font-semibold text-center text-gray-500" }
const _hoisted_13 = { class: "grid grid-cols-3 md:grid-cols-3 lg:grid-cols-6 gap-2 mt-4 text-gray-700 text-xs md:text-sm content-start" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "font-bold" }
const _hoisted_16 = { class: "w-full border border-gray-300 py-2 text-center font-semibold text-gray-500 shadow-md rounded-xl mt-4" }
const _hoisted_17 = { class: "w-full grid grid-cols-1 md:grid-cols-2 gap-2 mt-4 text-gray-700 text-xs md:text-sm content-start" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "flex-shrink-0" }
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 1,
  class: "w-12 h-12 rounded-full border border-[#bbc1a9] bg-gray-300"
}
const _hoisted_22 = { class: "flex flex-col justify-center md:text-center ml-3 md:ml-0" }
const _hoisted_23 = { class: "font-sm font-semibold leading-tight" }
const _hoisted_24 = { class: "font-sm font-semibold leading-tight" }
const _hoisted_25 = { class: "w-full border border-gray-300 py-2 text-center font-semibold text-gray-500 shadow-md rounded-xl mt-4" }
const _hoisted_26 = { class: "p-3 flex flex-col md:flex-row gap-2 justify-end w-full mt-2 bg-gray-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_NavPill = _resolveComponent("NavPill")!
  const _component_DataView = _resolveComponent("DataView")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Field = _resolveComponent("Field")!
  const _component_BlockUI = _resolveComponent("BlockUI")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "m-5 w-full md:w-9/12 lg:w-6/12 h-max-[90vh] overflow-y-auto",
        onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.closeDialog(false)), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_BlockUI, { visible: _ctx.blocked }, {
              default: _withCtx(() => [
                (_ctx.blocked)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_component_ProgressSpinner, {
                        style: {"width":"50px","height":"50px"},
                        strokeWidth: "5",
                        fill: "transparent",
                        animationDuration: ".5s"
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['far', 'fa-clock'],
                      class: "w-6 h-6 text-white"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('titulo.pedir.cita')), 1),
                  (_ctx.itemMeetingSeleccionado.empresa)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.itemMeetingSeleccionado.empresa.nombreFantasia || _ctx.$t('label.sin.empresa')), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_NavPill, {
                    items: _ctx.fechas,
                    modelValue: _ctx.fechaSeleccionada,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fechaSeleccionada) = $event)),
                    onChange: _ctx.onChangeFechaCronograma
                  }, null, 8, ["items", "modelValue", "onChange"]),
                  _createVNode(_component_DataView, {
                    value: _ctx.cronogramasUnicos,
                    paginator: "",
                    rows: 18,
                    alwaysShowPaginator: false,
                    dataKey: "item.id",
                    class: "!bg-transparent"
                  }, {
                    empty: _withCtx(() => [
                      (_ctx.blocked)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('label.cargando')), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('label.no.hay.mas.horarios')), 1)
                          ]))
                    ]),
                    list: _withCtx((slotProps) => [
                      _createElementVNode("div", _hoisted_13, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotProps.items, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: item.id
                          }, [
                            _createElementVNode("a", {
                              onClick: ($event: any) => (_ctx.seleccionarCita(item)),
                              class: _normalizeClass([item.id == _ctx.citaSeleccionada?.id ? 'bg-[#424c42] text-white' : 'bg-white', "w-full flex flex-row text-sm items-center justify-center py-3 border border-gray-600 text-black shadow-md rounded-xl transform transition-transform duration-200 hover:scale-[103%] cursor-pointer"])
                            }, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: ['far', 'fa-clock'],
                                class: "relative top-[2px] mr-1"
                              }),
                              _createElementVNode("span", _hoisted_15, _toDisplayString(item.horaDesde), 1)
                            ], 10, _hoisted_14)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }, 8, ["value"]),
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('label.acreditados.disponibles')), 1),
                  _createElementVNode("div", _hoisted_17, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.acreditadosDisponibles, (item, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        onClick: ($event: any) => (_ctx.acreditadosHabilitados.includes(item.id) && _ctx.seleccionarAcreditado(item)),
                        class: _normalizeClass([
                      'w-full flex flex-row md:flex-col items-center md:justify-center p-3 border border-gray-600 shadow-md rounded-xl transform transition-transform duration-200',
                      // Habilitado / Deshabilitado
                      _ctx.acreditadosHabilitados.includes(item.id)
                        ? 'cursor-pointer hover:scale-[101%]'
                        : 'opacity-40 cursor-not-allowed',
                      // Seleccionado
                      item.id === _ctx.acreditadoSeleccionado?.id
                        ? 'bg-[#424c42] text-white'
                        : 'bg-white'
                    ])
                      }, [
                        _createElementVNode("div", _hoisted_19, [
                          (item.foto)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: item.foto,
                                class: "w-12 h-12 rounded-full border border-[#bbc1a9] object-cover bg-white"
                              }, null, 8, _hoisted_20))
                            : (_openBlock(), _createElementBlock("div", _hoisted_21))
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, _toDisplayString(item.nombre), 1),
                          _createElementVNode("div", _hoisted_24, _toDisplayString(item.apellido), 1)
                        ])
                      ], 10, _hoisted_18))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('label.motivo.cita')), 1),
                  _createVNode(_component_Field, {
                    name: "motivoCita",
                    modelValue: _ctx.motivoCita,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.motivoCita) = $event))
                  }, {
                    default: _withCtx(({ field, errors }) => [
                      _createVNode(_component_Textarea, _mergeProps(field, {
                        rows: "4",
                        type: "text",
                        placeholder: _ctx.$t('label.ingres.motivo.cita'),
                        class: ["input-base w-full border border-gray-300 py-2 pl-2 pr-2 text-gray-500 !shadow-md rounded-xl mt-4", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]
                      }), null, 16, ["placeholder", "class"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("a", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.tomarCita && _ctx.tomarCita(...args))),
                    class: "cursor-pointer px-6 text-sm font-bold text-[#424c42] bg-transparent py-3 border border-[#424c42] shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95"
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'fa-check-double'] }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.tomar.cita')), 1)
                  ]),
                  _createElementVNode("a", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closeDialog(false))),
                    class: "cursor-pointer px-6 text-sm font-bold text-red-500 bg-transparent py-3 border border-red-500 shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95"
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'fa-xmark'] }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.cancelar')), 1)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["visible"])
          ])
        ])
      ])
    ])
  ]))
}